import Slider from 'react-slick';
import styled from 'styled-components';
import { setRem } from '../../utils/styles';

export const SliderWrapper = styled(Slider)`
  height: calc((100vh - ${setRem(130)}) / 2);
  overflow: hidden;
  position: relative;
  z-index: 2;
`;

export const SliderSlide = styled.img`
  display: block;
`;
